// extracted by mini-css-extract-plugin
module.exports = {"register_for_remove_ads":"ads_register_for_remove_ads__2jUl3"};